var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-xs-12" }, [_vm._t("default")], 2),
    _vm._v(" "),
    _c("div", { staticClass: "col-xs-12 trivia-scratch-out" }, [
      _c(
        "div",
        { staticClass: "scratch-out-options" },
        [
          _vm._l(_vm.question.options, function (option) {
            return _c(
              "div",
              {
                key: option.id,
                staticClass: "scratch-out-item",
                class: _vm.itemClass(option.id),
                on: {
                  click: function ($event) {
                    return _vm.toggleOption(option.id)
                  },
                },
              },
              [
                _c("p", {
                  staticClass: "scratch-out-text",
                  domProps: { innerHTML: _vm._s(option.text) },
                }),
              ]
            )
          }),
          _vm._v(" "),
          _vm.questionAnswered
            ? _c(
                "div",
                { staticClass: "trivia-result-indicator" },
                [
                  _vm.isCorrect
                    ? _c("check", { staticClass: "svg-icon large" })
                    : _c("incorrect", { staticClass: "svg-icon large" }),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "scratch-out-submit" }, [
        !_vm.questionAnswered
          ? _c(
              "button",
              {
                staticClass: "btn primary-btn",
                attrs: { disabled: _vm.selectedOptions.length === 0 },
                on: {
                  click: function ($event) {
                    return _vm.$emit("answer", _vm.selectedOptions)
                  },
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("CONTINUE")) +
                    "\n            "
                ),
              ]
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }